import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import Home from './Home'

const MapaDoSite = lazy(() => import('./MapaDoSite'))
const ResultadoPesquisa = lazy(() => import('./ResultadoPesquisa'))
const ConteudoGrupo = lazy(() => import('./ConteudoGrupo'))

const Acessibilidade = lazy(() => import('./Acessibilidade'))

const ConsultaLicitacao = lazy(() => import('../modulos/materiais/consultaLicitacao'))
const ConsultaLicitacaoMP = lazy(() => import('../modulos/materiais/consultaLicitacao/consultaLicitacaoMP'))
const RespostasImpugnacoesPedidosMP = lazy(() => import('../modulos/materiais/consultaLicitacao/respostasImpugnacoesPedidosMP'))
const DispensasInexigibilidadesMP = lazy(() => import('../modulos/materiais/consultaLicitacao/dispensasInexigibilidadesMP'))
const InteresseContratacaoDispensaMP = lazy(() => import('../modulos/materiais/consultaLicitacao/interesseContratacaoDispensaMP'))
const ChamamentoInteressadosMP = lazy(() => import('../modulos/materiais/consultaLicitacao/chamamentoInteressadosMP'))
const RolLicitantesMP = lazy(() => import('../modulos/materiais/consultaLicitacao/rolLicitantesMP'))
const ConsultaLicitacaoCovid = lazy(() => import('../modulos/materiais/consultaLicitacaoCovid'))
const DetalhesLicitacao = lazy(() => import('../modulos/materiais/detalhesLicitacao'))
const ConsultaBem = lazy(() => import('../modulos/materiais/consultaBem'))
const ConsultaContrato = lazy(() => import('../modulos/materiais/consultaContrato'))
const ConsultaContratoCovid = lazy(() => import('../modulos/materiais/consultaContratoCovid'))
const DetalhesContrato = lazy(() => import('../modulos/materiais/detalhesContrato'))
const DetalhesContratoLicitacao = lazy(() => import('../modulos/materiais/detalhesContratoLicitacao'))
const ConsultaContratoMP = lazy(() => import('../modulos/materiais/consultaContrato/consultaContratoMP'))
const ConsultaPrestadoresServicosEmpresasTerceirizadas = lazy(() => import('../modulos/materiais/consultaPrestadoresServicosEmpresasTerceirizadas'))

const DespesasPorOrgao = lazy(() => import('../modulos/contabilidade/despesasPorOrgao'))
const DespesasPorUnidade = lazy(() => import('../modulos/contabilidade/despesasPorUnidade'))
const DespesasPorRubrica = lazy(() => import('../modulos/contabilidade/despesasPorRubrica'))
const DespesasPorCredor = lazy(() => import('../modulos/contabilidade/despesasPorCredor'))
const DespesasPorEmpenho = lazy(() => import('../modulos/contabilidade/despesasPorEmpenho'))
const DetalhesEmpenho = lazy(() => import('../modulos/contabilidade/detalhesEmpenho'))
const GruposContabeis = lazy(() => import('../modulos/contabilidade/gruposContabeis'))
const ReceitaArrecadada = lazy(() => import('../modulos/contabilidade/receitaArrecadada'))
const OperacoesDespesas = lazy(() => import('../modulos/contabilidade/operacoesDespesas'))
const OperacoesDespesasGerais = lazy(() => import('../modulos/contabilidade/operacoesDespesas'))
const ConsultaDiarias = lazy(() => import('../modulos/contabilidade/consultaDiarias'))
const TransfFinAdm = lazy(() => import('../modulos/contabilidade/transfFinAdm'))
const DetalhesTransfFinAdm = lazy(() => import('../modulos/contabilidade/detalhesTransfFinAdm'))
const DetalhamentoLancamentoTransfFinAdm = lazy(() => import('../modulos/contabilidade/detalhamentoLancamentoTransfFinAdm'))
const ConsultaRemuneracao = lazy(() => import('../modulos/contabilidade/consultaRemuneracao'))
const DetalhesRemuneracao = lazy(() => import('../modulos/contabilidade/detalhesRemuneracao'))
const ConsultaBensImoveis = lazy(() => import('../modulos/materiais/consultaBensImoveis'))
const ConsultaConvenioParceriaConcedido = lazy(() => import('../modulos/contabilidade/consultaConvenioParceriaConcedido'))
const ConsultaConvenioParceriaRecebido = lazy(() => import('../modulos/contabilidade/consultaConvenioParceriaRecebido'))
const DetalhesRecursoConcedido = lazy(() => import('../modulos/contabilidade/detalhesRecursoConcedido'))
const DetalhesRecursoRecebido = lazy(() => import('../modulos/contabilidade/detalhesRecursoRecebido'))
const ConsultaMetasEducacao = lazy(() => import('../modulos/contabilidade/consultaMetasEducacao'))
const ConsultaOrdemCronologicaPagamento = lazy(() => import('../modulos/contabilidade/consultaOrdemCronologicaPagamento'))
const ReceitaDiaria = lazy(() => import('../modulos/contabilidade/receitaDiaria'))
const DetalhesOrdemCronologicaPagamento = lazy(() => import('../modulos/contabilidade/detalhesOrdemCronologicaPagamento'))
const DetalhesMetasEducacaoOrgao = lazy(() => import('../modulos/contabilidade/detalhesMetasEducacaoOrgao'))
const DetalhesMetasEducacaoEmpenho = lazy(() => import('../modulos/contabilidade/detalhesMetasEducacaoEmpenho'))
const DetalhesMetasEducacaoLiquidacao = lazy(() => import('../modulos/contabilidade/detalhesMetasEducacaoLiquidacao'))
const ConsultaEmpenhoCredor = lazy(() => import('../modulos/contabilidade/consultaEmpenhoCredor'))
const ConsultaAtaRegistroPrecoMP = lazy(() => import('../modulos/materiais/consultaAtaRegistroPrecoMP'))
const ConsultaAtaRegistroPreco = lazy(() => import('../modulos/materiais/consultaAtaRegistroPreco'))
const DetalhesAtaRegistroPreco = lazy(() => import('../modulos/materiais/detalhesAtaRegistroPreco'))
const ConsultaAdvertenciaFornecedor = lazy(() => import('../modulos/materiais/consultaAdvertenciaFornecedor'))
const SancoesAplicadasContratados = lazy(() => import('../modulos/materiais/consultaAdvertenciaFornecedor/sancoesAplicadasContratados'))
const ListaEmpresasSuspensasImpedidas = lazy(() => import('../modulos/materiais/consultaAdvertenciaFornecedor/listaEmpresasSuspensasImpedidas'))
const DetalhesAdvertenciaFornecedor = lazy(() => import('../modulos/materiais/detalhesAdvertenciaFornecedor'))
const DetalhesReceitaDiaria = lazy(() => import('../modulos/contabilidade/detalhesReceitaDiaria'))
const DetalhesBensImoveis = lazy(() => import('../modulos/materiais/detalhesBensImoveis'))
const ConsultaPlanoAnualContratacoes = lazy(() => import('../modulos/contabilidade/consultaPlanoAnualContratacoes'))
const ConsultaListaObrasParadas = lazy(() => import('../modulos/materiais/consultaListaObrasParadas'))
const DetalhesObrasParadas = lazy(() => import('../modulos/materiais/detalhesObrasParadas'))
const ConsultaBensImoveisMP = lazy(() => import('../modulos/materiais/consultaBensImoveis/consultaBensImoveisMP'))
const DetalhesPlanosAnuaisContratacoes = lazy(() => import('../modulos/contabilidade/detalhesPlanosAnuaisContratacoes'))
const ConsultaRemuneracaoADMRH = lazy(() => import('../modulos/ADMRH/consultaRemuneracaoADMRH'))
const ConsultaDetalhamentoDespesas = lazy(() => import('../modulos/contabilidade/consultaDetalhamentoDespesas'))
const ConsultaRestosPagar = lazy(() => import('../modulos/contabilidade/consultaRestosPagar'))
const ConsultaCreditoOrcamentarioReceitasProprias = lazy(() => import('../modulos/contabilidade/consultaCreditoOrcamentarioReceitasProprias'))
const ConsultaFundosSaldosReceitas = lazy(() => import('../modulos/contabilidade/consultaFundosSaldosReceitas'))
const ConsultaOrdemCronologicaPagamentoMP = lazy(() => import('../modulos/contabilidade/consultaOrdemCronologicaPagamentoMP'))
const ConsultaDiariasPassagens = lazy(() => import('../modulos/contabilidade/consultaDiariasPassagens'))
const ConsultaDespesasCartaoCorporativo = lazy(() => import('../modulos/contabilidade/consultaDespesasCartaoCorporativo'))
const ConsultaPagamentoContraCheque = lazy(() => import('../modulos/contabilidade/consultaPagamentoContraCheque'))
const ConsultaRepassesFundosInstitutosPrevidenciarios = lazy(() => import('../modulos/contabilidade/consultaRepassesFundosInstitutosPrevidenciarios'))
const ConsultaListaIndicadoresPlanejamentoEstrategico = lazy(() => import('../modulos/planejamentoEstrategico/consultaListaIndicadoresPlanejamentoEstrategico'))
const ConsultaDespesasPorAcaoOrcamentaria = lazy(() => import('../modulos/contabilidade/consultaDespesasPorAcaoOrcamentaria'))
const ConsultaPlanoPlurianual = lazy(() => import('../modulos/contabilidade/consultaPlanoPlurianual'))
const ConsultaConveniosInstrumentosCongeneres = lazy(() => import('../modulos/contabilidade/consultaConveniosInstrumentosCongeneres'))
const DetalhesDespesasCartaoCorporativo = lazy(() => import('../modulos/contabilidade/detalhesDespesasCartaoCorporativo'))
const ConsultaPrestacaoContasAnual = lazy(() => import('../modulos/contabilidade/consultaPrestacaoContasAnual'))
const DetalhesPrestacaoContasAnual = lazy(() => import('../modulos/contabilidade/detalhesPrestacaoContasAnual'))
const QuadrosAtivosADMRH = lazy(() => import('../modulos/ADMRH/quadrosAtivosADMRH'))
const ConsultaQuadroInativosADMRH = lazy(() => import('../modulos/ADMRH/consultaQuadroInativosADMRH'))
const DetalhesLicitacaoDispensa = lazy(() => import('../modulos/materiais/detalhesLicitacao/detalhesLicitacaoDispensas'))
const ConsultaPensionistasADMRH = lazy(() => import('../modulos/ADMRH/consultaPensionistasADMRH'))
const ConsultaCedidosPeloMP = lazy(() => import('../modulos/ADMRH/consultaCedidosMP'))
const ConsultaCedidosParaMP = lazy(() => import('../modulos/ADMRH/consultaCedidosParaMP'))
const ConsultaMembrosFuncoesGratificadas = lazy(() => import('../modulos/ADMRH/consultaMembrosFuncoesGratificadas'))
const ConsultaServidoresFuncoesGratificadas = lazy(() => import('../modulos/ADMRH/consultaServidoresFuncoesGratificadas'))
const ConsultaServidoresEmTeletrabalho = lazy(() => import('../modulos/ADMRH/consultaServidoresEmTeletrabalho'))
const ConsultaEstagiariosMP = lazy(() => import('../modulos/ADMRH/consultaEstagiariosMP'))
const ConsultaCargosComissaoMP = lazy(() => import('../modulos/ADMRH/consultaCargosComissaoMP'))
const ConsultaCargosVagosOcupadosMembros = lazy(() => import('../modulos/ADMRH/consultaCargosVagosOcupadosMembros'))
const ConsultaCargosVagosOcupadosServidores = lazy(() => import('../modulos/ADMRH/consultaCargosVagosOcupadosServidores'))
const ConsultaConcursoSelecoes = lazy(() => import('../modulos/ADMRH/consultaConcursoSelecoes'))
const DetalhesAdiantamentosSuprimentos = lazy(() => import('../modulos/contabilidade/detalhesAdiantamentosSuprimentos'))
const ConsultaProvimentosServidores = lazy(() => import('../modulos/ADMRH/consultaProvimentosServidores'))
const ConsultaAdiantamentosSuprimentos = lazy(() => import('../modulos/contabilidade/consultaAdiantamentosSuprimentos'))
const ConsultaProvimentosMembros = lazy(() => import('../modulos/ADMRH/consultaProvimentosMembros'))
const ConsultaVerbasIndenizatorias = lazy(() => import('../modulos/ADMRH/consultaVerabasIndenizatorias'))
const ConsultaVerbasExerciciosAnteriores = lazy(() => import('../modulos/ADMRH/consultaVerbasExerciciosAnteriores'))
const ConsultaVacanciasMembros = lazy(() => import('../modulos/ADMRH/consultaVacancias'))
const ConsultaVacanciasServidores = lazy(() => import('../modulos/ADMRH/consultaVacancias'))
const DetalhesExperienciaProfissional = lazy(() => import('../modulos/ADMRH/detalhesExperienciaProfissional'))
const DetalhesEscolaridadeCurriculos = lazy(() => import('../modulos/ADMRH/detalhesEscolaridadeCurriculos'))
const ConsultaCurriculos = lazy(() => import('../modulos/ADMRH/consultaCurriculos'))
const ConsultaOrdensPagamentosExtraorcamentarias = lazy(() => import('../modulos/contabilidade/consultaOrdensPagamentosExtraorcamentarias'))
const DetalhesOrdensPagamentosExtraorcamentarias = lazy(() => import('../modulos/contabilidade/detalhesOrdensPagamentosExtraorcamentarias'))
const ConsultaObrasExterno = lazy(() => import('../modulos/materiais/consultaObras'))
const ConsultaReceitasExtraorcamentarias = lazy(() => import('../modulos/contabilidade/consultaReceitasExtraorcamentarias'))
const ConsultaEmpenhoCredorAquisicoesDiretas = lazy(() => import('../modulos/contabilidade/consultaEmpenhoCredorAquisicoesDiretas'))
const DespesasMensais = lazy(() => import('../modulos/contabilidade/despesasMensais'))
const DespesasMensaisPorFornecedor = lazy(() => import('../modulos/contabilidade/despesasMensaisPorFornecedor'))
const DetalhesPrestacao = lazy(() => import('../modulos/contabilidade/detalhesPrestacao'))

const ProgramaWebComponent = lazy(() => import('../modulos/infra/programaWebComponent'))

const programas = [
    {
        id: 1,
        path: '/',
        marca: 'Início',
        render: p => <Home titulo="Início do Portal da Transparência" {...p} />,
        exact: true,
        estaNoMapa: true,
    },
    {
        id: 2,
        path: '/consultaLicitacao',
        marca: 'Consulta Licitação',
        render: p => <ConsultaLicitacao {...p} />,
        exact: true,
    },
    {
        id: 3,
        path: '/consultaLicitacao/detalhesLicitacao/:param',
        marca: 'Detalhes da Licitação',
        render: p => <DetalhesLicitacao {...p} />,
        exact: true,
    },
    {
        id: 4,
        path: '/consultaLicitacao/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 5,
        path: '/consultaLicitacao/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 6,
        path: '/consultaContrato',
        marca: 'Consulta Contrato',
        render: p => <ConsultaContrato {...p} />,
        exact: true,
    },
    {
        id: 7,
        path: '/consultaContrato/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 8,
        path: '/consultaContrato/detalhesContrato/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 9,
        path: '/despesasPorOrgaos/unidades/rubrica/:param',
        marca: 'Despesas por Rubrica',
        render: p => <DespesasPorRubrica {...p} />,
        exact: true,
    },
    {
        id: 10,
        path: '/despesasPorOrgaos/unidades/:param',
        marca: 'Despesas por Unidade',
        render: p => <DespesasPorUnidade {...p} />,
        exact: true,
    },
    {
        id: 11,
        path: '/despesasPorOrgaos/unidades/rubrica/credor/:param',
        marca: 'Despesas por Credor',
        render: p => <DespesasPorCredor {...p} />,
        exact: true,
    },
    {
        id: 12,
        path: '/despesasPorOrgaos/unidades/rubrica/credor/empenho/:param',
        marca: 'Despesas por Empenho',
        render: p => <DespesasPorEmpenho {...p} />,
        exact: true,
    },
    {
        id: 13,
        path: '/despesasPorOrgaos/unidades/rubrica/credor/empenho/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 14,
        path: '/despesasPorOrgaos',
        marca: 'Despesas por Órgãos',
        render: p => <DespesasPorOrgao />,
        exact: true,
    },
    {
        id: 15,
        path: '/gruposReceitas',
        marca: 'Grupo de Receitas',
        render: p => <GruposContabeis tituloPrograma="Grupo de Receitas" modelo="TRRE" />,
        exact: true,
    },
    {
        id: 16,
        path: '/gruposDespesas',
        marca: 'Grupo de Despesas',
        render: p => <GruposContabeis tituloPrograma="Grupo de Despesas" modelo="TRAN" />,
        exact: true,
    },
    {
        id: 17,
        path: '/gruposAcoes',
        marca: 'Grupo de Ações',
        render: p => <GruposContabeis tituloPrograma="Grupo de Ações" modelo="TRANSPACAO" />,
        exact: true,
    },
    {
        id: 18,
        path: '/gruposAcoes/operacoesDespesas/:param',
        marca: 'Operações Despesas',
        render: p => <OperacoesDespesas {...p} />,
        exact: true,
    },
    {
        id: 19,
        path: '/gruposAcoes/operacoesDespesas/empenho/:param',
        marca: 'Despesas por Empenho',
        render: p => <DespesasPorEmpenho {...p} />,
        exact: true,
    },
    {
        id: 20,
        path: '/gruposAcoes/operacoesDespesas/empenho/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 21,
        path: '/gruposReceitas/receitaArrecadada/:param',
        marca: 'Receita Arrecadada',
        render: p => <ReceitaArrecadada {...p} />,
        exact: true,
    },
    {
        id: 22,
        path: '/gruposDespesas/operacoesDespesas/:param',
        marca: 'Operações Despesas',
        render: p => <OperacoesDespesas {...p} />,
        exact: true,
    },
    {
        id: 23,
        path: '/gruposDespesas/operacoesDespesas/empenho/:param',
        marca: 'Despesas por Empenho',
        render: p => <DespesasPorEmpenho {...p} />,
        exact: true,
    },
    {
        id: 24,
        path: '/gruposDespesas/operacoesDespesas/empenho/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 25,
        path: '/acessibilidade',
        marca: 'Acessibilidade',
        render: p => <Acessibilidade {...p} />,
        exact: true,
        estaNoMapa: true,
    },
    {
        id: 26,
        path: '/consultaDiarias',
        marca: 'Consulta de Diárias',
        render: p => <ConsultaDiarias {...p} />,
        exact: true,
    },
    {
        id: 27,
        path: '/consultaDiarias/empenho/:param',
        marca: 'Despesas por Empenho',
        render: p => <DespesasPorEmpenho {...p} />,
        exact: true,
    },
    {
        id: 28,
        path: '/consultaDiarias/empenho/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 29,
        path: '/mapaDoSite',
        marca: 'Mapa do Site',
        render: p => <MapaDoSite titulo="Mapa do Site" programas={programas} {...p} />,
        exact: true,
    },
    {
        id: 30,
        path: '/resultadoPesquisa',
        marca: 'Resultado da Pesquisa',
        exact: true,
    },
    {
        id: 31,
        path: '/conteudoGrupo/:param',
        marca: 'Conteúdo',
        render: p => <ConteudoGrupo {...p} />,
        exact: true,
    },
    {
        id: 32,
        path: '/transfFinAdm',
        marca: 'Transferências Financeiras entre Administrações',
        render: p => <TransfFinAdm {...p} />,
        exact: true,
    },
    {
        id: 33,
        path: '/consultaBem',
        marca: 'Consulta Bens Frota',
        render: p => <ConsultaBem {...p} />,
        exact: true,
    },
    {
        id: 34,
        path: '/transfFinAdm/detalhes/:param',
        marca: 'Detalhes Transferências',
        render: p => <DetalhesTransfFinAdm {...p} />,
        exact: true,
    },
    {
        id: 35,
        path: '/receitaArrecadada',
        marca: 'Receita Arrecadada',
        render: p => <ReceitaArrecadada {...p} />,
        exact: true,
    },
    {
        id: 36,
        path: '/consultaRemuneracao',
        marca: 'Consulta Remunerações',
        render: p => <ConsultaRemuneracao {...p} />,
        exact: true,
    },
    {
        id: 37,
        path: '/consultaRemuneracao/detalhesRemuneracao/:param',
        marca: 'Detalhes Remuneração',
        render: p => <DetalhesRemuneracao {...p} />,
        exact: true,
    },
    {
        id: 38,
        path: '/consultaBensImoveis',
        marca: 'Consulta de Bens - Imóveis',
        render: p => <ConsultaBensImoveis {...p} />,
        exact: true,
    },
    {
        id: 39,
        path: '/consultaConvenioParceriaConcedido',
        marca: 'Consulta Convênio e Parceria Concedidos',
        render: p => <ConsultaConvenioParceriaConcedido {...p} />,
        exact: true,
    },
    {
        id: 40,
        path: '/consultaConvenioParceriaRecebido',
        marca: 'Consulta Convênio e Parceria Recebidos',
        render: p => <ConsultaConvenioParceriaRecebido {...p} />,
        exact: true,
    },
    {
        id: 41,
        path: '/consultaConvenioParceriaConcedido/detalhesRecursoConcedido/:param',
        marca: 'Detalhes Instrumento de Parceria – Recurso Concedido',
        render: p => <DetalhesRecursoConcedido {...p} />,
        exact: true,
    },
    {
        id: 42,
        path: '/consultaConvenioParceriaRecebido/detalhesRecursoRecebido/:param',
        marca: 'Detalhes Instrumento de Parceria – Recurso Recebido',
        render: p => <DetalhesRecursoRecebido {...p} />,
        exact: true,
    },
    {
        id: 43,
        path: '/gruposDespesasGerais',
        marca: 'Grupo de Despesas Gerais',
        render: p => <GruposContabeis tituloPrograma="Grupo de Despesas Gerais" modelo="LDPT" />,
        exact: true,
    },
    {
        id: 44,
        path: '/consultaMetasEducacao',
        marca: 'Consulta Metas da Educação',
        render: p => <ConsultaMetasEducacao {...p} />,
        exact: true,
    },
    {
        id: 45,
        path: '/consultaLicitacaoCovid',
        marca: 'Consulta Licitação - Covid - 19',
        render: p => <ConsultaLicitacaoCovid {...p} />,
        exact: true,
    },
    {
        id: 46,
        path: '/consultaContratoCovid',
        marca: 'Consulta Contrato - Covid - 19',
        render: p => <ConsultaContratoCovid {...p} />,
        exact: true,
    },
    {
        id: 47,
        path: '/consultaOrdemCronologicaPagamento',
        marca: 'Ordem Cronológica de Pagamentos',
        render: p => <ConsultaOrdemCronologicaPagamento {...p} />,
        exact: true,
    },
    {
        id: 48,
        path: '/receitaDiaria',
        marca: 'Receita Diária',
        render: p => <ReceitaDiaria {...p} />,
        exact: true,
    },
    {
        id: 49,
        path: '/consultaOrdemCronologicaPagamento/detalhesOrdemCronologicaPagamento/:param',
        marca: 'Detalhes da Ordem Cronológica de Pagamentos',
        render: p => <DetalhesOrdemCronologicaPagamento {...p} />,
        exact: true,
    },
    {
        id: 50,
        path: '/consultaMetasEducacao/detalhesMetasEducacaoOrgao/:param',
        marca: 'Metas da Educação por Órgãos',
        render: p => <DetalhesMetasEducacaoOrgao {...p} />,
        exact: true,
    },
    {
        id: 51,
        path: '/consultaMetasEducacao/detalhesMetasEducacaoOrgao/detalhesMetasEducacaoEmpenho/:param',
        marca: 'Metas da Educação por Empenho',
        render: p => <DetalhesMetasEducacaoEmpenho {...p} />,
        exact: true,
    },
    {
        id: 52,
        path: '/consultaMetasEducacao/detalhesMetasEducacaoOrgao/detalhesMetasEducacaoEmpenho/detalhesMetasEducacaoLiquidacao/:param',
        marca: 'Metas da Educação – Detalhes Liquidação',
        render: p => <DetalhesMetasEducacaoLiquidacao {...p} />,
        exact: true,
    },
    {
        id: 52,
        path: '/consultaEmpenhoCredor',
        marca: 'Consulta Empenhos Credores',
        render: p => <ConsultaEmpenhoCredor {...p} />,
        exact: true,
    },
    {
        id: 53,
        path: '/consultaAtaRegistroPreco',
        marca: 'Consulta Ata de Registro de Preço',
        render: p => <ConsultaAtaRegistroPreco {...p} />,
        exact: true,
    },
    {
        id: 54,
        path: '/consultaAtaRegistroPreco/detalhesAtaRegistroPreco/:param',
        marca: 'Detalhes - Ata de Registro de Preço',
        render: p => <DetalhesAtaRegistroPreco {...p} />,
        exact: true,
    },
    {
        id: 55,
        path: '/consultaAdvertenciaFornecedor',
        marca: 'Advertências do Fornecedor',
        render: p => <ConsultaAdvertenciaFornecedor {...p} />,
        exact: true,
    },
    {
        id: 56,
        path: '/consultaAdvertenciaFornecedor/detalhesAdvertenciaFornecedor/:param',
        marca: 'Detalhes - Advertências do Fornecedor',
        render: p => <DetalhesAdvertenciaFornecedor {...p} />,
        exact: true,
    },
    {
        id: 57,
        path: '/consultaLicitacao/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 58,
        path: '/receitaDiaria/detalhesReceitaDiaria/:param',
        marca: 'Detalhes da Receita Diária',
        render: p => <DetalhesReceitaDiaria {...p} />,
        exact: true,
    },
    {
        id: 59,
        path: '/consultaEmpenhoCredor/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 60,
        path: '/consultaLicitacaoCovid/detalhesLicitacao/:param',
        marca: 'Detalhes da Licitação',
        render: p => <DetalhesLicitacao {...p} />,
        exact: true,
    },
    {
        id: 61,
        path: '/consultaContratoCovid/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 62,
        path: '/consultaLicitacaoCovid/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 63,
        path: '/consultaLicitacaoCovid/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 64,
        path: '/consultaContratoCovid/detalhesContrato/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 65,
        path: '/consultaConvenioParceriaConcedido/detalhesRecursoConcedido/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 66,
        path: '/sancoesAplicadasContratados',
        marca: 'Sanções Aplicadas Aos Contratados',
        render: p => <SancoesAplicadasContratados {...p} />,
        exact: true,
    },
    {
        id: 67,
        path: '/consultaBensImoveisMP',
        marca: 'Bens Imóveis',
        render: p => <ConsultaBensImoveisMP {...p} />,
        exact: true,
    },
    {
        id: 68,
        path: '/listaEmpresasSuspensasImpedidas',
        marca: 'Lista De Empresas Suspensas Ou Impedidas',
        render: p => <ListaEmpresasSuspensasImpedidas {...p} />,
        exact: true,
    },
    {
        id: 69,
        path: '/consultaListaObrasParadas',
        marca: 'Lista de Obras Paradas',
        render: p => <ConsultaListaObrasParadas {...p} />,
        exact: true,
    },
    {
        id: 70,
        path: '/consultaBensImoveis/detalhesBensImoveis/:param',
        marca: 'Detalhes dos bens imóveis',
        render: p => <DetalhesBensImoveis {...p} />,
        exact: true,
    },
    {
        id: 71,
        path: '/consultaPlanoAnualContratacoes',
        marca: 'Plano Anual de Contratações',
        render: p => <ConsultaPlanoAnualContratacoes {...p} />,
        exact: true,
    },
    {
        id: 72,
        path: '/consultaBensImoveisMP/detalhesBensImoveis/:param',
        marca: 'Detalhes dos bens imóveis',
        render: p => <DetalhesBensImoveis {...p} />,
        exact: true,
    },
    {
        id: 73,
        path: '/consultaPlanoAnualContratacoes/detalhesPlanoAnualContratacoes/:param',
        marca: 'Detalhes dos planos anuais de contratações',
        render: p => <DetalhesPlanosAnuaisContratacoes {...p} />,
        exact: true,
    },
    {
        id: 74,
        path: '/sancoesAplicadasContratados/detalhesAdvertenciaFornecedor/:param',
        marca: 'Detalhes - Sanções Aplicadas Aos Contratados',
        render: p => <DetalhesAdvertenciaFornecedor {...p} />,
        exact: true,
    },
    {
        id: 75,
        path: '/consultaAtaRegistroPrecoMP',
        marca: 'Atas de Registro de Preços Próprias ou Aderidas',
        render: p => <ConsultaAtaRegistroPrecoMP {...p} />,
        exact: true,
    },
    {
        id: 76,
        path: '/listaEmpresasSuspensasImpedidas/detalhesAdvertenciaFornecedor/:param',
        marca: 'Detalhes - Lista De Empresas Suspensas Ou Impedidas',
        render: p => <DetalhesAdvertenciaFornecedor {...p} />,
        exact: true,
    },
    {
        id: 77,
        path: '/consultaListaObrasParadas/detalhesObrasParadas/:param',
        marca: 'Detalhes de obras paradas',
        render: p => <DetalhesObrasParadas {...p} />,
        exact: true,
    },
    {
        id: 78,
        path: '/consultaContratoMP',
        marca: 'Consulta Contrato',
        render: p => <ConsultaContratoMP />,
        exact: true,
    },
    {
        id: 79,
        path: '/consultaAtaRegistroPrecoMP/detalhesAtaRegistroPreco/:param',
        marca: 'Detalhes - Ata de Registro de Preço',
        render: p => <DetalhesAtaRegistroPreco {...p} />,
        exact: true,
    },
    {
        id: 80,
        path: '/consultaContratoMP/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato contratoMP="S" {...p} />,
        exact: true,
    },
    {
        id: 81,
        path: '/consultaContratoMP/detalhesContrato/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 82,
        path: '/respostasImpugnacoesPedidosMP',
        marca: 'Respostas às Impugnações e Pedidos de Esclarecimentos– MP',
        render: p => <RespostasImpugnacoesPedidosMP {...p} />,
        exact: true,
    },
    {
        id: 83,
        path: '/dispensasInexigibilidadesMP',
        marca: 'Dispensas e Inexigibilidades – MP',
        render: p => <DispensasInexigibilidadesMP {...p} />,
        exact: true,
    },
    {
        id: 84,
        path: '/interesseContratacaoDispensaMP',
        marca: 'Aviso de Interesse em Contratação por Dispensa – MP',
        render: p => <InteresseContratacaoDispensaMP {...p} />,
        exact: true,
    },
    {
        id: 85,
        path: '/chamamentoInteressadosMP',
        marca: 'Edital de Chamamento de Interessados – MP',
        render: p => <ChamamentoInteressadosMP {...p} />,
        exact: true,
    },
    {
        id: 86,
        path: '/rolLicitantesMP',
        marca: 'Rol de Licitantes e Bens Pré-Qualificados – MP',
        render: p => <RolLicitantesMP {...p} />,
        exact: true,
    },
    {
        id: 87,
        path: '/consultaLicitacaoMP',
        marca: 'Licitações – MP',
        render: p => <ConsultaLicitacaoMP {...p} />,
        exact: true,
    },
    {
        id: 88,
        path: '/consultaLicitacaoMP/detalhesLicitacao/:param',
        marca: 'Detalhes - Licitações MP',
        render: p => <DetalhesLicitacao {...p} />,
        exact: true,
    },
    {
        id: 89,
        path: '/rolLicitantesMP/detalhesLicitacao/:param',
        marca: 'Detalhes - Rol de Licitantes e Bens Pré-Qualificados MP',
        render: p => <DetalhesLicitacao {...p} />,
        exact: true,
    },
    {
        id: 90,
        path: '/chamamentoInteressadosMP/detalhesLicitacao/:param',
        marca: 'Detalhes - Edital de Chamamento de Interessados MP',
        render: p => <DetalhesLicitacao {...p} />,
        exact: true,
    },
    {
        id: 91,
        path: '/interesseContratacaoDispensaMP/detalhesLicitacao/:param',
        marca: 'Detalhes - Aviso de Interesse em Contratação por Dispensa MP',
        render: p => <DetalhesLicitacaoDispensa {...p} />,
        exact: true,
    },
    {
        id: 92,
        path: '/dispensasInexigibilidadesMP/detalhesLicitacao/:param',
        marca: 'Detalhes - Dispensas e Inexigibilidades MP',
        render: p => <DetalhesLicitacaoDispensa {...p} />,
        exact: true,
    },
    {
        id: 93,
        path: '/respostasImpugnacoesPedidosMP/detalhesLicitacao/:param',
        marca: 'Detalhes - Respostas às Impugnações e Pedidos de Esclarecimentos MP',
        render: p => <DetalhesLicitacao {...p} />,
        exact: true,
    },
    {
        id: 94,
        path: '/consultaDetalhamentoDespesas',
        marca: 'Detalhamento das Despesas',
        render: p => <ConsultaDetalhamentoDespesas />,
        exact: true,
    },
    {
        id: 95,
        path: '/consultaRemuneracaoTodosMenbrosAtivos',
        marca: 'Remuneração de todos os membros ativos',
        render: p => <ConsultaRemuneracaoADMRH {...p} tipoServidor="1" />,
        exact: true,
    },
    {
        id: 96,
        path: '/consultaRemuneracaoTodosMembrosInativos',
        marca: 'Proventos de todos os membros inativos',
        render: p => <ConsultaRemuneracaoADMRH {...p} tipoServidor="2" />,
        exact: true,
    },
    {
        id: 98,
        path: '/consultaRemuneracaoTodosServidoresAtivos',
        marca: 'Remuneração de todos os servidores ativos',
        render: p => <ConsultaRemuneracaoADMRH {...p} tipoServidor="3" />,
        exact: true,
    },
    {
        id: 99,
        path: '/consultaRemuneracaoTodosServidoresInativos',
        marca: 'Proventos de todos os servidores inativos',
        render: p => <ConsultaRemuneracaoADMRH {...p} tipoServidor="4" />,
        exact: true,
    },
    {
        id: 100,
        path: '/consultaRemuneracaoPercebidosTodosPensionistas',
        marca: 'Valores percebidos por todos os pensionistas',
        render: p => <ConsultaRemuneracaoADMRH {...p} tipoServidor="5" />,
        exact: true,
    },
    {
        id: 101,
        path: '/consultaRemuneracaoPercebidosTodosColaboradores',
        marca: 'Valores percebidos por todos os colaboradores',
        render: p => <ConsultaRemuneracaoADMRH {...p} tipoServidor="6" />,
        exact: true,
    },
    {
        id: 102,
        path: '/consultaFundosSaldosReceitas',
        marca: 'Fundos: Saldos e Receitas',
        render: p => <ConsultaFundosSaldosReceitas />,
        exact: true,
    },
    {
        id: 103,
        path: '/consultaPrestadoresServicosEmpresasTerceirizadas',
        marca: 'Prestadores de Serviços por Empresas Terceirizadas',
        render: p => <ConsultaPrestadoresServicosEmpresasTerceirizadas />,
        exact: true,
    },
    {
        id: 104,
        path: '/consultaCreditoOrcamentarioReceitasProprias',
        marca: 'Crédito Orçamentário e Receitas Próprias',
        render: p => <ConsultaCreditoOrcamentarioReceitasProprias />,
        exact: true,
    },
    {
        id: 105,
        path: '/ordemCronologicaPagamentosBens',
        marca: 'Ordem Cronológica - Pagamentos de Fornecimento de Bens',
        render: p => <ConsultaOrdemCronologicaPagamentoMP grupos="1" path="/ordemCronologicaPagamentosBens" />,
        exact: true,
    },
    {
        id: 106,
        path: '/ordemCronologicaPrestacaoServicos',
        marca: 'Ordem Cronológica - Prestação de Serviços',
        render: p => <ConsultaOrdemCronologicaPagamentoMP grupos="2" path="/ordemCronologicaPrestacaoServicos" />,
        exact: true,
    },
    {
        id: 107,
        path: '/ordemCronologicaPagamentosLocacoes',
        marca: 'Ordem Cronológica - Pagamentos de Locações',
        render: p => <ConsultaOrdemCronologicaPagamentoMP grupos="3" path="/ordemCronologicaPagamentosLocacoes" />,
        exact: true,
    },
    {
        id: 108,
        path: '/ordemCronologicaRealizacaoObras',
        marca: 'Ordem Cronológica - Realização de Obras',
        render: p => <ConsultaOrdemCronologicaPagamentoMP grupos="4" path="/ordemCronologicaRealizacaoObras" />,
        exact: true,
    },
    {
        id: 109,
        path: '/ordemCronologicaPagamentosBens/detalhesOrdemCronologicaPagamento/:param',
        marca: 'Detalhes da Ordem Cronológica de Pagamentos',
        render: p => <DetalhesOrdemCronologicaPagamento {...p} />,
        exact: true,
    },
    {
        id: 110,
        path: '/ordemCronologicaPrestacaoServicos/detalhesOrdemCronologicaPagamento/:param',
        marca: 'Detalhes da Ordem Cronológica de Pagamentos',
        render: p => <DetalhesOrdemCronologicaPagamento {...p} />,
        exact: true,
    },
    {
        id: 111,
        path: '/ordemCronologicaPagamentosLocacoes/detalhesOrdemCronologicaPagamento/:param',
        marca: 'Detalhes da Ordem Cronológica de Pagamentos',
        render: p => <DetalhesOrdemCronologicaPagamento {...p} />,
        exact: true,
    },
    {
        id: 112,
        path: '/ordemCronologicaRealizacaoObras/detalhesOrdemCronologicaPagamento/:param',
        marca: 'Detalhes da Ordem Cronológica de Pagamentos',
        render: p => <DetalhesOrdemCronologicaPagamento {...p} />,
        exact: true,
    },
    {
        id: 113,
        path: '/consultaRestosPagar',
        marca: 'Restos a Pagar',
        render: p => <ConsultaRestosPagar />,
        exact: true,
    },
    {
        id: 114,
        path: '/consultaDespesasCartaoCorporativo',
        marca: 'Despesas com Cartão Corporativo e Suprimento de Fundos',
        render: p => <ConsultaDespesasCartaoCorporativo />,
        exact: true,
    },
    {
        id: 115,
        path: '/consultaPlanoPlurianual',
        marca: 'Plano Plurianual',
        render: p => <ConsultaPlanoPlurianual />,
        exact: true,
    },
    {
        id: 116,
        path: '/consultaRepassesFundosInstitutosPrevidenciarios',
        marca: 'Repasses a Fundos e Institutos Previdenciários',
        render: p => <ConsultaRepassesFundosInstitutosPrevidenciarios />,
        exact: true,
    },
    {
        id: 117,
        path: '/consultaListaIndicadoresPlanejamentoEstrategico',
        marca: 'Lista de Indicadores do Planejamento Estratégico',
        render: p => <ConsultaListaIndicadoresPlanejamentoEstrategico />,
        exact: true,
    },
    {
        id: 118,
        path: '/consultaDespesasPorAcaoOrcamentaria',
        marca: 'Despesas por Ação Orçamentária',
        render: p => <ConsultaDespesasPorAcaoOrcamentaria />,
        exact: true,
    },
    {
        id: 119,
        path: '/consultaPagamentoContraCheque',
        marca: 'Outros Benefícios: pagamentos não registrados em contracheque',
        render: p => <ConsultaPagamentoContraCheque />,
        exact: true,
    },
    {
        id: 120,
        path: '/consultaLicitacaoCovid/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 121,
        path: '/consultaDespesasCartaoCorporativo/detalhesDespesasCartaoCorporativo/:param',
        marca: 'Despesas com Cartão Corporativo e Suprimento de Fundos - Detalhes',
        render: p => <DetalhesDespesasCartaoCorporativo {...p} />,
        exact: true,
    },
    {
        id: 122,
        path: '/consultaConveniosInstrumentosCongeneres',
        marca: 'Convênios e Instrumentos Congêneres',
        render: p => <ConsultaConveniosInstrumentosCongeneres />,
        exact: true,
    },
    {
        id: 123,
        path: '/consultaPrestacaoContaAnual',
        marca: 'Prestação de Contas Anual ',
        render: p => <ConsultaPrestacaoContasAnual />,
        exact: true,
    },
    {
        id: 124,
        path: '/transfFinAdm/detalhes/detalhamentoLancamento/:param',
        marca: 'Detalhamento Lançamentos',
        render: p => <DetalhamentoLancamentoTransfFinAdm {...p} />,
    },
    {
        id: 125,
        path: '/consultaPrestacaoContaAnual/detalhesPrestacaoContasAnual/:param',
        marca: 'Detalhes - Prestação de Contas Anual',
        render: p => <DetalhesPrestacaoContasAnual {...p} />,
        exact: true,
    },
    {
        id: 126,
        path: '/consultaLicitacaoMP/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 127,
        path: '/consultaLicitacaoMP/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 128,
        path: '/respostasImpugnacoesPedidosMP/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 129,
        path: '/respostasImpugnacoesPedidosMP/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 130,
        path: '/dispensasInexigibilidadesMP/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 131,
        path: '/dispensasInexigibilidadesMP/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 132,
        path: '/interesseContratacaoDispensaMP/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 133,
        path: '/interesseContratacaoDispensaMP/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 134,
        path: '/chamamentoInteressadosMP/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 135,
        path: '/chamamentoInteressadosMP/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 136,
        path: '/rolLicitantesMP/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 137,
        path: '/rolLicitantesMP/detalhesLicitacao/detalhesContratoLicitacao/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContratoLicitacao {...p} />,
        exact: true,
    },
    {
        id: 138,
        path: '/consultaQuadrosMembrosInativos',
        marca: 'Quadro de Membros Inativos Portal da Transparência do MP - ADMRH',
        render: p => <ConsultaQuadroInativosADMRH {...p} tipoServidor="2" />,
        exact: true,
    },
    {
        id: 139,
        path: '/quadrosMembrosAtivos',
        marca: 'Quadro de Membros Ativos Portal da Transparência do MP - ADMRH',
        render: p => <QuadrosAtivosADMRH {...p} tipoServidor="1" />,
        exact: true,
    },
    {
        id: 140,
        path: '/consultaQuadrosServidoresInativos',
        marca: 'Quadro de Servidores Inativos Portal da Transparência do MP - ADMRH',
        render: p => <ConsultaQuadroInativosADMRH {...p} tipoServidor="4" />,
        exact: true,
    },
    {
        id: 141,
        path: '/quadrosServidoresAtivos',
        marca: 'Quadro de Servidores Ativos Portal da Transparência do MP - ADMRH',
        render: p => <QuadrosAtivosADMRH {...p} tipoServidor="3" />,
        exact: true,
    },
    {
        id: 142,
        path: '/consultaConveniosInstrumentosCongeneres/detalhesRecursoConcedido/:param',
        marca: 'Detalhes Convênios e Instrumentos Congêneres',
        render: p => <DetalhesRecursoConcedido {...p} />,
        exact: true,
    },
    {
        id: 143,
        path: '/consultaDiariasPassagens',
        marca: 'Diárias e Passagens',
        render: p => <ConsultaDiariasPassagens />,
        exact: true,
    },
    {
        id: 144,
        path: '/consultaCedidosPeloMP',
        marca: 'Cedidos pelo MP',
        render: p => <ConsultaCedidosPeloMP {...p} tipoServidor="8" />,
        exact: true,
    },
    {
        id: 145,
        path: '/consultaCedidosParaMP',
        marca: 'Consulta Cedidos Para o MP',
        render: p => <ConsultaCedidosParaMP {...p} tipoServidor="7" />,
        exact: true,
    },
    {
        id: 146,
        path: '/consultaPensionistasADMRH',
        marca: 'Pensionistas Portal da Transparência do MP - ADMRH',
        render: p => <ConsultaPensionistasADMRH {...p} tipoServidor="5" />,
        exact: true,
    },
    {
        id: 147,
        path: '/respostasImpugnacoesPedidosMP/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 148,
        path: '/interesseContratacaoDispensaMP/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 149,
        path: '/dispensasInexigibilidadesMP/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 150,
        path: '/consultaLicitacaoMP/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 151,
        path: '/rolLicitantesMP/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 152,
        path: '/chamamentoInteressadosMP/detalhesLicitacao/detalhesContratoLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 153,
        path: '/consultaMembrosFuncoesGratificadas',
        marca: 'Consulta Membros Com Funções Gratificadas Portal da Transparência MP - ADMRH',
        render: p => <ConsultaMembrosFuncoesGratificadas tipoServidor="1" />,
        exact: true,
    },
    {
        id: 154,
        path: '/consultaServidoresFuncoesGratificadas',
        marca: 'Consulta Servidores Com Funções Gratificadas Portal da Transparência MP - ADMRH',
        render: p => <ConsultaServidoresFuncoesGratificadas tipoServidor="3" />,
        exact: true,
    },
    {
        id: 155,
        path: '/consultaServidoresEmTeletrabalho',
        marca: 'Servidores em Teletrabalho',
        render: p => <ConsultaServidoresEmTeletrabalho {...p} tipoServidor="3" />,
        exact: true,
    },
    {
        id: 156,
        path: '/consultaEstagiariosMP',
        marca: 'Consulta Estagiários  Portal da Transparência MP - ADMRH',
        render: p => <ConsultaEstagiariosMP {...p} tipoServidor="9" />,
        exact: true,
    },
    {
        id: 157,
        path: '/consultaCargosComissao',
        marca: 'Consulta Cargos em Comissão e Funções de Confiança Ocupados e Vagos por Membros e Servidores',
        render: p => <ConsultaCargosComissaoMP {...p} />,
        exact: true,
    },
    {
        id: 158,
        path: '/consultaCargosVagosOcupadosServidores',
        marca: 'Cargos Vagos e Ocupados - Servidores',
        render: p => <ConsultaCargosVagosOcupadosServidores {...p} tipoServidor="3" />,
        exact: true,
    },
    {
        id: 159,
        path: '/consultaCargosVagosOcupadosMembros',
        marca: 'Cargos Vagos e Ocupados - Membros',
        render: p => <ConsultaCargosVagosOcupadosMembros {...p} tipoServidor="1" />,
        exact: true,
    },
    {
        id: 160,
        path: '/consultaConcursoSelecoes',
        marca: 'Consulta Concursos e Seleções Portal da Transparência MP - ADMRH',
        render: p => <ConsultaConcursoSelecoes {...p} />,
        exact: true,
    },
    {
        id: 161,
        path: '/consultaAdiantamentosSuprimentos',
        marca: 'Adiantamentos e Suprimentos',
        render: p => <ConsultaAdiantamentosSuprimentos {...p} />,
        exact: true,
    },
    {
        id: 162,
        path: '/consultaProvimentosMembros',
        marca: 'Consulta Provimentos Membros MP - Portal da Transparência - ADMRH',
        render: p => <ConsultaProvimentosMembros {...p} tipoServidor="1" />,
        exact: true,
    },
    {
        id: 163,
        path: '/consultaAdiantamentosSuprimentos/detalhesAdiantamentosSuprimentos/:param',
        marca: 'Detalhes Adiantamentos e Suprimentos',
        render: p => <DetalhesAdiantamentosSuprimentos {...p} />,
        exact: true,
    },
    {
        id: 164,
        path: '/consultaProvimentosServidores',
        marca: 'Consulta Provimentos Servidores MP - Portal da Transparência - ADMRH',
        render: p => <ConsultaProvimentosServidores {...p} tipoServidor="3" />,
        exact: true,
    },
    {
        id: 165,
        path: '/consultaVerbasIndenizatorias',
        marca: 'Verbas Indenizatórias MP',
        render: p => <ConsultaVerbasIndenizatorias {...p} tipoServidor="2" />,
        exact: true,
    },
    {
        id: 166,
        path: '/consultaVerbasExerciciosAnteriores',
        marca: 'Verbas Exercicios Anteriores MP',
        render: p => <ConsultaVerbasExerciciosAnteriores {...p} tipoServidor="2" />,
        exact: true,
    },
    {
        id: 167,
        path: '/consultaVacanciasMembros',
        marca: 'Consulta Vacâncias Membros MP - Portal da Transparência - ADMRH',
        render: p => <ConsultaVacanciasMembros {...p} tipoServidor="1" />,
        exact: true,
    },
    {
        id: 168,
        path: '/consultaVacanciasServidores',
        marca: 'Consulta Vacâncias Servidores MP - Portal da Transparência - ADMRH',
        render: p => <ConsultaVacanciasServidores {...p} tipoServidor="3" />,
        exact: true,
    },
    {
        id: 169,
        path: '/consultaCurriculos',
        marca: 'Consulta Currículos MP',
        render: p => <ConsultaCurriculos {...p} />,
        exact: true,
    },
    {
        id: 170,
        path: '/consultaCurriculos/detalhesEscolaridadeCurriculos/:param',
        marca: 'Detalhe Escolaridade Currículos',
        render: p => <DetalhesEscolaridadeCurriculos {...p} />,
        exact: true,
    },
    {
        id: 171,
        path: '/consultaCurriculos/detalhesEscolaridadeCurriculos/detalhesExperienciaProfissional/:param',
        marca: 'Detalhes Experiência Profissional',
        render: p => <DetalhesExperienciaProfissional {...p} />,
        exact: true,
    },
    {
        id: 172,
        path: '/gruposDespesasGerais/operacoesDespesas/:param',
        marca: 'Operações Despesas',
        render: p => <OperacoesDespesasGerais {...p} />,
        exact: true,
    },
    {
        id: 173,
        path: '/gruposDespesasGerais/operacoesDespesas/empenho/:param',
        marca: 'Despesas por Empenho',
        render: p => <DespesasPorEmpenho {...p} />,
        exact: true,
    },
    {
        id: 174,
        path: '/gruposDespesasGerais/operacoesDespesas/empenho/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 175,
        path: '/consultaOrdensPagamentosExtraorcamentarias',
        marca: 'Ordens Pagamentos Extraorçamentárias',
        render: p => <ConsultaOrdensPagamentosExtraorcamentarias {...p} />,
        exact: true,
    },
    {
        id: 176,
        path: '/consultaOrdensPagamentosExtraorcamentarias/detalhesOrdensPagamentosExtraorcamentarias/:param',
        marca: 'Ordens Pagamentos Extraorçamentárias - Detalhes',
        render: p => <DetalhesOrdensPagamentosExtraorcamentarias {...p} />,
        exact: true,
    },
    {
        id: 177,
        path: '/consultaObrasExterno',
        marca: 'Consulta Obras',
        render: p => <ConsultaObrasExterno {...p} />,
        exact: true,
    },
    {
        id: 178,
        path: '/consultaObrasExterno/detalhesObrasParadas/:param',
        marca: 'Detalhes de obras paradas',
        render: p => <DetalhesObrasParadas {...p} />,
        exact: true,
    },
    {
        id: 179,
        path: '/consultaAtaRegistroPreco/detalhesAtaRegistroPreco/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 180,
        path: '/consultaReceitasExtraorcamentarias',
        marca: 'Receitas Extraorçamentárias',
        render: p => <ConsultaReceitasExtraorcamentarias {...p} />,
        exact: true,
    },
    {
        id: 181,
        path: '/consultaLicitacao/detalhesLicitacao/detalhesAtasRegistroPreco/:param',
        marca: 'Detalhes - Ata de Registro de Preço',
        render: p => <DetalhesAtaRegistroPreco {...p} />,
        exact: true,
    },
    {
        id: 182,
        path: '/consultaLicitacao/detalhesLicitacao/detalhesRecursoConcedido/:param',
        marca: 'Detalhes Convênios',
        render: p => <DetalhesRecursoConcedido {...p} />,
        exact: true,
    },
    {
        id: 183,
        path: '/consultaLicitacao/detalhesLicitacao/detalhesRecursoConcedido/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 184,
        path: '/consultaConveniosInstrumentosCongeneres/detalhesRecursoConcedido/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 185,
        path: '/consultaEmpenhoCredorAquisicoesDiretas',
        marca: 'Consulta Empenhos Credores – Aquisições Diretas',
        render: p => <ConsultaEmpenhoCredorAquisicoesDiretas {...p} />,
        exact: true,
    },
    {
        id: 186,
        path: '/consultaEmpenhoCredorAquisicoesDiretas/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 187,
        path: '/ordemCronologicaPagamentosBens/detalhesOrdemCronologicaPagamento/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 188,
        path: '/ordemCronologicaPrestacaoServicos/detalhesOrdemCronologicaPagamento/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 189,
        path: '/ordemCronologicaPagamentosLocacoes/detalhesOrdemCronologicaPagamento/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 190,
        path: '/ordemCronologicaRealizacaoObras/detalhesOrdemCronologicaPagamento/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 191,
        path: '/consultaOrdemCronologicaPagamento/detalhesOrdemCronologicaPagamento/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 192,
        path: '/ordemCronologicaPagamentosBens/detalhesOrdemCronologicaPagamento/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 193,
        path: '/ordemCronologicaPrestacaoServicos/detalhesOrdemCronologicaPagamento/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 194,
        path: '/ordemCronologicaPagamentosLocacoes/detalhesOrdemCronologicaPagamento/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 195,
        path: '/ordemCronologicaRealizacaoObras/detalhesOrdemCronologicaPagamento/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 196,
        path: '/consultaOrdemCronologicaPagamento/detalhesOrdemCronologicaPagamento/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 197,
        path: '/despesasMensais',
        marca: 'Despesas Mensais',
        render: p => <DespesasMensais {...p} />,
        exact: true,
    },
    {
        id: 198,
        path: '/despesasMensais/despesasMensaisPorFornecedor/:param',
        marca: 'Despesas Mensais por Fornecedor',
        render: p => <DespesasMensaisPorFornecedor {...p} />,
        exact: true,
    },
    {
        id: 199,
        path: '/consultaConvenioParceriaConcedido/detalhesRecursoConcedido/detalhesPrestacao/:param',
        marca: 'Detalhes da Prestação',
        render: p => <DetalhesPrestacao {...p} />,
        exact: true,
    },
    {
        id: 200,
        path: '/consultaAtaRegistroPreco/detalhesAtaRegistroPreco/detalhesContrato/:param',
        marca: 'Detalhes do Contrato',
        render: p => <DetalhesContrato {...p} />,
        exact: true,
    },
    {
        id: 201,
        path: '/consultaAtaRegistroPreco/detalhesAtaRegistroPreco/detalhesLicitacao/:param',
        marca: 'Detalhes da Licitação',
        render: p => <DetalhesLicitacao {...p} />,
        exact: true,
    },
    {
        id: 202,
        path: '/contabilidade/consultaEmpenhoCredorWC',
        marca: 'Consulta Empenho Credor',
        render: p => <ProgramaWebComponent {...p} />,
        exact: true,
      },
    {
        id: 203,
        path: '/receitasEmergenciais',
        marca: 'Receitas Emergenciais',
        render: p => <GruposContabeis tituloPrograma="Grupo de Receitas" modelo="REG" />,
        exact: true,
    },
    {
        id: 204,
        path: '/receitasEmergenciais/receitaArrecadada/:param',
        marca: 'Receita Arrecadada',
        render: p => <ReceitaArrecadada {...p} />,
        exact: true,
    },
    {
        id: 205,
        path: '/gruposDespesasEmergenciais',
        marca: 'Despesas Emergenciais',
        render: p => <GruposContabeis tituloPrograma="Grupo de Despesas" modelo="DEC" />,
        exact: true,
    },
    {
        id: 206,
        path: '/gruposDespesasEmergenciais/operacoesDespesas/:param',
        marca: 'Operações Despesas',
        render: p => <OperacoesDespesas {...p} />,
        exact: true,
    },
    {
        id: 207,
        path: '/gruposDespesasEmergenciais/operacoesDespesas/empenho/:param',
        marca: 'Despesas por Empenho',
        render: p => <DespesasPorEmpenho {...p} />,
        exact: true,
    },
    {
        id: 208,
        path: '/gruposDespesasEmergenciais/operacoesDespesas/empenho/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
    {
        id: 209,
        path: '/consultaAtaRegistroPreco/detalhesLicitacao/detalhesEmpenho/:param',
        marca: 'Detalhes do Empenho',
        render: p => <DetalhesEmpenho {...p} />,
        exact: true,
    },
]

function Programas({ resultados }) {
    programas[29].render = p => <ResultadoPesquisa titulo="Resultado da Pesquisa" resultados={resultados} {...p} />

    return (
        <>
            {programas.map((p, i) => (
                <Route key={i} {...p} />
            ))}
        </>
    )
}

export { programas }
export default Programas
